import Decimal from 'decimal.js-light';
import { DECIMAL_DIGITS } from 'src/modules/common/constants';

export const areaFieldResultAm = (areaWidth: string, areaHeight: string) => {
    const width = new Decimal(areaWidth || 0);
    const height = new Decimal(areaHeight || 0);

    return width.dividedBy(12).mul(height.dividedBy(12)).toFixed(DECIMAL_DIGITS);
};

export const areaFieldResultEmea = (areaWidth: string, areaHeight: string) => {
    const width = new Decimal(areaWidth || 0);
    const height = new Decimal(areaHeight || 0);

    return width.dividedBy(1000).mul(height.dividedBy(1000)).toFixed(DECIMAL_DIGITS);
};
